// import Navbar from "react-bootstrap/Navbar";
// import Nav from "react-bootstrap/Nav";
// import Container from "react-bootstrap/Container";
import { Fragment, useEffect, useState } from "react";
import { getCateListData } from "../../context/apiState.js";
import styles from "../header/HeaderMenu.module.css";
import CommonCategory from "./CommonCategory.js";
import CategoryLazyLoadImage from "../LazyImageLoad/LOadImages.jsx";
import HttpBaseUrl from "./../../httpservice/common.http.js";

function HeaderMenu(props) {
  const [allCateData, setAllCateData] = useState();
  const [isToggle, setIsToggle] = useState(false);

  let lang = localStorage.getItem("language") ? localStorage.getItem("language") : 1;

  async function callAllCategory() {
    let allCategoryData = await getCateListData();
    if (allCategoryData) {
      setAllCateData(allCategoryData);
    }
  }

  const getIdFromToken = (adToken) => {
    if (adToken) {
      let idFromToken = adToken.split(".")[1].split("@@")[0];
    
      return idFromToken;
    }
  };

  // Toggle menu 
  function toggleMenu() {
    let toggelClass = document.getElementById("navListId");
    let toggleImg = document.getElementById("toggleIds");
      toggleImg.src = !isToggle ? `${HttpBaseUrl.getAssetsPath()}/crossIcon.png` : `${HttpBaseUrl.getAssetsPath()}/toggleIcon.png`;
      toggelClass.style.left = !isToggle ? "0" : "-2400px";
      toggelClass.style.width = !isToggle ? "85%" : "0";
      document.body.style.overflow = !isToggle ? "hidden" : "unset";
      document.getElementById('basic-navbar-nav').style.pointerEvents = !isToggle ? "none" : "auto";
      if(document.getElementById("trendingId")){
        document.getElementById("trendingId").style.pointerEvents = !isToggle ? "none" : "auto";
       }else if(document.getElementById("commonToggleCate")){
        document.getElementById("commonToggleCate").style.pointerEvents = !isToggle ? "none" : "auto";
       }

    setIsToggle(!isToggle);
  }
//  hide toggle when click outside
let toggleIcon = document.querySelector("#toggleBtnId");
let menuSidebar = document.querySelector("#navListId");
let toggleImg = document.getElementById("toggleIds");
document.onclick = function(e){
  if (!toggleIcon.contains(e.target) && !menuSidebar.contains(e.target) ) {
    toggleImg.src = `${HttpBaseUrl.getAssetsPath()}/toggleIcon.png`
      menuSidebar.style.left="-2400px";
      document.body.style.overflow = "unset";
      document.getElementById('basic-navbar-nav').style.pointerEvents = "auto";
      if(document.getElementById("trendingId")){
        document.getElementById("trendingId").style.pointerEvents = "auto";        
      }else if(document.getElementById("commonToggleCate")){
        document.getElementById("commonToggleCate").style.pointerEvents = "auto";        
       }
      setIsToggle(!isToggle);
  }
}
  const changeLanguage = (lang) => {
    localStorage.setItem("language", lang);
    //  alert("language change " + lang)
    window.location.reload();
  }

  useEffect(() => {
    window.onload=callAllCategory();
  }, []);

  return (
    <>
    <meta charset="UTF-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>Seekapeek</title>
      <nav expand="lg" className="Navbar" sticky="top">
        <div className={styles.mobileMenuScroll + " container "}>
          <a href="/" id={styles.navBrandColor}>
            {/* <CategoryLazyLoadImage dataSrc={`${HttpBaseUrl.getAssetsPath()}/logo.webp`}  alt="logo"  width="230px" height="110px"/> */}
            <img src={`${HttpBaseUrl.getAssetsPath()}/logo.webp`} />
          </a>
          {/* Toggle menu start */}
          <div className={styles.toggle_Menu}>
            <div className={styles.toggle_btn} onClick={toggleMenu} id="toggleBtnId">
              <label  htmlFor="toggle_check">
                {/* <span className="toggleBtnSpan" id="toggleBtn1"></span>
                <span id="toggleBtn3"></span>
                <span className="toggleBtnSpan" id="toggleBtn2"></span> */}
                <img src={`${HttpBaseUrl.getAssetsPath()}/toggleIcon.png`} id="toggleIds" className={styles.toggleWidth} />
              </label>
            </div>
            <div className={`toggleMenuCl ${styles.nav_list}`} id="navListId">
              <a id={styles.navbarId} className={!props.headerConfig.catId ? styles.headerActive : ""} href="/">
                <img src={`${HttpBaseUrl.getAssetsPath()}/home.png`} loading="lazy" alt="home" fetchpriority="high" width="20px" height="20px" style={{  marginRight: "3px" }} />
                {lang == 2 ? process.env.REACT_APP_HOME_HIN : process.env.REACT_APP_HOME_ENG}
              </a>
              <a href="#"> <img src={`${HttpBaseUrl.getAssetsPath()}/language_icon.svg`} loading="lazy" alt="language" width="20px" height="20px" fetchPriority = "high" style={{  marginRight: "3px" }} />
                {lang == 2 ? process.env.REACT_APP_CHOOSE_LANGUAGE_HIN : process.env.REACT_APP_CHOOSE_LANGUAGE_ENG}
                <ul className={styles.languageTypes}>
                  <li onClick={() => changeLanguage(1)} className={
                    localStorage.getItem("language") == 1 || "" ? "text-primary" : ""
                  }>{lang == 2 ? process.env.REACT_APP_ENGLISH_HIN : process.env.REACT_APP_ENGLISH_ENG}</li>
                  <li onClick={() => changeLanguage(2)} className={
                    localStorage.getItem("language") == 2 ? "text-primary" : ""
                  }>{lang == 2 ? process.env.REACT_APP_HINDI_HIN : process.env.REACT_APP_HINDI_ENG}</li>
                </ul>
              </a>
              <div id="list-div" className={styles.toggleUlAf}>
                <CommonCategory allCateData={allCateData} headerConfig={props.headerConfig} />
              </div>
            </div>
          </div>
          <div id="basic-navbar-nav" className={styles.navbarWidth}>
            <nav className={" ms-auto " + styles.headerNav}>
              <a
                id={styles.navbarId}
                className={!props.headerConfig.catId ? styles.headerActive : ""}
                href="/"
              >
                {lang == 2 ? process.env.REACT_APP_HOME_HIN : process.env.REACT_APP_HOME_ENG}
              </a>
              <CommonCategory allCateData={allCateData} headerConfig={props.headerConfig} />
            </nav>
          </div>
        </div>
      </nav>
    </>
  );
}

export default HeaderMenu;
